import React, { useEffect, useState, useContext } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Stack from "@mui/material/Stack";
import ButtonGroup from "@mui/material/ButtonGroup";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveIcon from "@mui/icons-material/Remove";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import ProjectContext from "../../context/ProjectContext";
import MyContext from "../../context/MyContext";
import Chip from "@mui/material/Chip";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
const SlideTimeChangeModal = (props) => {
  const time = props.value.SmallTime.split(" ")[0];
  const [tempTime, setTempTime] = useState(time);
  const [updatedTime, setupdatedTime] = useState(time);
  const [isValidated, setisValidated] = useState(false);
  const [error, seterror] = useState(false);
  const { slides, setslides } = useContext(ProjectContext);

  useEffect(() => {
    setupdatedTime(time);
    seterror(false);
  }, [props.open]);
  const {
    setPrevious_TlTotalTime,
    Tl_TotalTime,
    calculateTimeByWidth,
    calculateWidthByDuration,
    LayersData,
    setTl_TotalTime,
    setisTextInputOrAreaFocus,
  } = useContext(MyContext);
  const handleClose = () => {
    props.setshowSlideTimeChangeModal(false);
  };

  function sec2time(timeInSeconds) {
    var pad = function (num, size) {
        return ("000" + num).slice(size * -1);
      },
      time = parseFloat(timeInSeconds).toFixed(3),
      hours = Math.floor(time / 60 / 60),
      minutes = Math.floor(time / 60) % 60,
      seconds = Math.floor(time - minutes * 60),
      milliseconds = time.slice(-3);

    return (
      pad(hours, 2) +
      ":" +
      pad(minutes, 2) +
      ":" +
      pad(seconds, 2) +
      ":" +
      pad(milliseconds, 3)
    );
  }

  const validateOnChange = (current, event) => {
    // const isNumber = /^[0-9]$/i.test(current.target.value);
    // if (current.target.value <= 300 && current.target.value > 0) {
    //   return true;
    // } else {
    //   return false;
    // }
  };

  const validateText = (current, event) => {
    // const isNumber = /^[0-9]$/i.test(current.key);
    // if (isNumber && current.target.value <= 300 && current.target.value > 0) {
    //   setTempTime(current.target.value);
    // }
    // // var a = isValid(current.target, current);
    // // if (a) setisValidated(true);
    // // else setisValidated(false);
  };
  function isValid(el, event) {
    var charC = event.which ? event.which : event.keyCode;
    if (charC === 189 || charC === 187) {
      return false;
    } else {
      return true;
    }
    // if (charC == 46) {
    //     if (el.value.indexOf('.') === -1) {
    //         return true;
    //     } else {
    //         return false;
    //     }
    // } else {
    //     if (charC > 31 && (charC < 48 || charC > 57))
    //         return false;
    // }
    // return true;
  }

  const updateSlideTime = () => {
    if (parseFloat(updatedTime) <= 0 || updatedTime.trim() === "") {
      seterror(true);
      return false;
    } else if (parseFloat(updatedTime) > 300) {
      seterror(true);
      return false;
    }

    var difference = 0;
    var widthDifference = 0;
    const array = Array.from(slides);
    //this is for decreasing the time
    if (parseFloat(updatedTime) < parseFloat(time)) {
      difference = parseFloat(time) - parseFloat(updatedTime);
      widthDifference = calculateWidthByDuration(sec2time(difference));

      for (var index = 0; index < array.length; index++) {
        if (index == props.slideNumber) {
          setPrevious_TlTotalTime({
            width: Tl_TotalTime.width,
            time: Tl_TotalTime.time,
          });

          setTl_TotalTime({
            time: updatedTime + " s",
            width: props.value.scaleEnd - widthDifference,
          });
          array[index].SmallTime = updatedTime + " s";
          array[index].isResized = true;

          array[index].scaleEnd = props.value.scaleEnd - widthDifference;
          //array[index].LayerData = LayersData;
          //array[index].offsetWidth = ref.offsetWidth;TotalSlideWidth

          array[index].TotalSlideWidth = array[index].scaleEnd;
          array[index].TotalLength = calculateTimeByWidth(
            array[index].scaleEnd
          );
          array[index].offsetWidth = calculateWidthByDuration(
            array[index].TotalLength
          );
        }
      }
      setslides(array);
    } else {
      difference = parseFloat(time) - parseFloat(updatedTime);
      widthDifference = calculateWidthByDuration(
        sec2time(Math.abs(difference))
      );

      for (var index = 0; index < array.length; index++) {
        if (index == props.slideNumber) {
          setPrevious_TlTotalTime({
            width: Tl_TotalTime.width,
            time: Tl_TotalTime.time,
          });

          setTl_TotalTime({
            time: updatedTime + " s",
            width: props.value.scaleEnd + widthDifference,
          });
          array[index].SmallTime = updatedTime + " s";
          array[index].isResized = true;

          array[index].scaleEnd = props.value.scaleEnd + widthDifference;
          //array[index].LayerData = LayersData;
          //array[index].offsetWidth = ref.offsetWidth;TotalSlideWidth

          array[index].TotalSlideWidth = array[index].scaleEnd;
          array[index].TotalLength = calculateTimeByWidth(
            array[index].scaleEnd
          );
          array[index].offsetWidth = calculateWidthByDuration(
            array[index].TotalLength
          );
        }
      }
      setslides(array);
    }

    handleClose();
  };

  return (
    <>
      <Dialog
        open={props.open}
        onClose={() => props.setshowSlideTimeChangeModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title mr-4"
          style={{ marginRight: "100px" }}
        >
          Change time for Slide Number: {Number(props.slideNumber) + 1}
          <IconButton
            onClick={() => props.setshowSlideTimeChangeModal(false)}
            style={{ position: "absolute", right: "10px", top: "10px" }}
            aria-label="Close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <Stack spacing={1} direction="row" flexWrap={"nowrap"}>
            <TextField
              onFocus={() => setisTextInputOrAreaFocus(true)}
              onBlur={() => setisTextInputOrAreaFocus(false)}
              id="filled-basic"
              value={updatedTime}
              //onKeyDown={(current, event) => validateText(current, event)}
              onChange={(current, event) => {
                setupdatedTime(current.target.value);
              }}
              label="Enter Seconds"
              variant="filled"
              type="number"
            />
            {/* <IconButton aria-label="Add" sx={{ width: "50px", height: "50px" }}>
              <AddCircleOutlineIcon />
            </IconButton>
            <IconButton aria-label="Add" sx={{ width: "50px", height: "50px" }}>
              <RemoveCircleOutlineIcon />
            </IconButton> */}

            {/* <Stack direction="column" sx={{ backgroundColor: "#e9e9e9" }}>
              <Stack className="number-btn" flexGrow={1} sx={{ px: 1.5 }}>
              <Chip icon={<AddIcon />} variant="outlined" />
              </Stack>
              <Stack flexGrow={1} sx={{ px: 1.5 }}>
                <Chip icon={<AddIcon />} variant="outlined" />
              </Stack>
            </Stack> */}
          </Stack>
          {error && (
            <Alert style={{ marginTop: "5px" }} severity="error">
              Value should be greater than 0 and less than 300 seconds. And you
              cannot leave it empty.
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={updateSlideTime}>Done</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SlideTimeChangeModal;
